import { Component, inject } from "@angular/core";
import { HeaderService, BootstrapIcon } from "src/app/services/header.service";
import { ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { NavigationService } from "src/app/shared/data-access/navigation.service";

enum childComponents {
  FormComponent = "userFormComponent",
  ViewComponent = "userViewComponent",
}

@Component({
  selector: "app-admin-usermanagement",
  template: `
    <h1 class="qundis-page-heading-h1">{{ getPageHeading() }}</h1>
    <router-outlet></router-outlet>
  `,
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, RouterModule],
})
export class AdminUsermanagementComponent {
  headerService = inject(HeaderService);
  navigationService = inject(NavigationService);

  async ngOnInit() {
    this.headerService.setHeaderTitle("Benutzerverwaltung");
    this.headerService.setHeaderIcon(BootstrapIcon.users);
  }

  getPageHeading() {
    switch (this.navigationService.activeComponent()) {
      case childComponents.ViewComponent:
        this.headerService.setHeaderSubTitle("Gesamtübersicht");
        return "Gesamtübersicht";
      case childComponents.FormComponent:
        if (this.navigationService.currentUrl().includes("formAction=edit")) {
          this.headerService.setHeaderSubTitle("Benutzer bearbeiten");
          return "Benutzer bearbeiten";
        } else {
          this.headerService.setHeaderSubTitle("Neuen Benutzer anlegen");
          return "Neuen Benutzer anlegen";
        }
      default:
        return "Gesamtübersicht";
    }
  }
}
